import React from "react";
import {
  ArtifactV1SessionPart,
  ArtifactV1SessionPartKind,
  NoteCreatedV1ArtifactPayload,
  NoteUpdatedV1ArtifactPayload,
  SessionArtifactPayload,
} from "../../session.types";
import { DateTime } from "luxon";
import { MemCommonEditorAssetProxyConfig } from "@mem-labs/common-editor";
import { MDSSessionArtifact } from "@/mds/components/sessions/session-context";
import { SessionArtifactNotePreviewRenderer } from "@/mds/components/sessions/session-parts/artifacts/session-artifact-note-preview-renderer";

interface Props {
  artifactPart: ArtifactV1SessionPart;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  resolveAssetProxy?: () => Promise<MemCommonEditorAssetProxyConfig | undefined>;
}

export const MDSSessionArtifactPreviewNoteRenderer: React.FC<Props> = ({
  artifactPart,
  onClick,
  resolveAssetProxy,
}) => {
  const artifact: MDSSessionArtifact = {
    kind: artifactPart.artifact_kind as ArtifactV1SessionPartKind,
    payload: artifactPart.artifact_payload as SessionArtifactPayload,
  };

  switch (artifact.kind) {
    case ArtifactV1SessionPartKind.NoteCreatedV1: {
      const payload = artifact.payload as NoteCreatedV1ArtifactPayload;

      return (
        <SessionArtifactNotePreviewRenderer
          onClick={onClick}
          resolveAssetProxy={resolveAssetProxy}
          data={{
            noteInfo: {
              noteId: payload.note_id,
              createdAt: DateTime.fromISO(payload.note_created_at),
              updatedAt: DateTime.fromISO(payload.note_updated_at),
              encodedContent: payload.encoded_content,
              primaryLabel: payload.primary_label,
              secondaryLabel: payload.secondary_label,
              markdownContent: payload.markdown_content,
            },
          }}
        />
      );
    }
    case ArtifactV1SessionPartKind.NoteUpdatedV1: {
      const payload = artifact.payload as NoteUpdatedV1ArtifactPayload;

      return (
        <SessionArtifactNotePreviewRenderer
          onClick={onClick}
          resolveAssetProxy={resolveAssetProxy}
          data={{
            noteInfo: {
              noteId: payload.note_id,
              createdAt: DateTime.fromISO(payload.note_created_at),
              updatedAt: DateTime.fromISO(payload.note_updated_at),
              encodedContent: payload.encoded_content,
              primaryLabel: payload.primary_label,
              secondaryLabel: payload.secondary_label,
              markdownContent: payload.markdown_content,
            },
            previousNoteInfo: {
              noteId: payload.note_id,
              createdAt: DateTime.fromISO(payload.note_created_at),
              updatedAt: DateTime.fromISO(payload.note_updated_at),
              encodedContent: payload.prev_encoded_content,
              primaryLabel: payload.prev_primary_label,
              secondaryLabel: payload.prev_secondary_label,
              markdownContent: payload.prev_markdown_content,
            },
            showDifferences: true,
          }}
        />
      );
    }
  }
};
